import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import { BrandingProvider } from "@/context/BrandingContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Cases from "@/pages/Cases";
import CaseDetail from "@/pages/CaseDetail";
import Referrals from "@/pages/Referrals";
import Audit from "@/pages/Audit";
import Users from "@/pages/Users";
import Analytics from "@/pages/Analytics";
import GeoMap from "@/pages/GeoMap";
import Workflows from "@/pages/Workflows";
import Settings from "@/pages/Settings";
import PublicImpact from "@/pages/PublicImpact";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-500 font-mono text-sm">Establishing secure session…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AnonOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user && user !== false) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
      <BrandingProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<AnonOnly><Login /></AnonOnly>} />
          <Route path="/register" element={<AnonOnly><Register /></AnonOnly>} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/cases" element={<Protected><Cases /></Protected>} />
          <Route path="/cases/:caseId" element={<Protected><CaseDetail /></Protected>} />
          <Route path="/referrals" element={<Protected><Referrals /></Protected>} />
          <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
          <Route path="/map" element={<Protected><GeoMap /></Protected>} />
          <Route path="/workflows" element={<Protected><Workflows /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/impact" element={<PublicImpact />} />
          <Route path="/audit" element={<Protected><Audit /></Protected>} />
          <Route path="/users" element={<Protected><Users /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
      </BrandingProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
